var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiotimeErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30699",
    "data-name": "Group 30699",
    transform: "translate(-304.535 -179.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_3925",
    "data-name": "Ellipse 3925",
    transform: "translate(304.535 179.357)",
    fill: "rgba(254,80,80,0.1)",
    stroke: "#fe5050",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    d: "M-244-129a22.065,22.065,0,0,0-22,22,22.065,22.065,0,0,0,22,22,22.065,22.065,0,0,0,22-22,22.065,22.065,0,0,0-22-22Zm0,0",
    transform: "translate(588.535 326.357)",
    fill: "#fe5050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_416",
    "data-name": "Union 416",
    d: "M0,14.4a2.4,2.4,0,1,1,2.4,2.4A2.4,2.4,0,0,1,0,14.4Zm1.056-6L.3,2.4a2.119,2.119,0,1,1,4.2,0l-.756,6a1.353,1.353,0,0,1-2.688,0Z",
    transform: "translate(342.135 211.357)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiotimeErrorIcon);
export default __webpack_public_path__ + "static/media/biotime-error-icon.fa9028f7cd3a12f85ab3cbae154f688b.svg";
export { ForwardRef as ReactComponent };